const KEY = 'plunk-recent-searches';
const MAX = 10;
export function getRecent() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}
export function addRecent(term) {
  const t = (term || '').trim();
  if (!t) return;
  try {
    const list = getRecent().filter(x => x.term.toLowerCase() !== t.toLowerCase());
    list.unshift({
      term: t,
      ts: Date.now()
    });
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
  } catch {}
}
export function clearRecent() {
  try {
    localStorage.removeItem(KEY);
  } catch {}
}
export default {
  getRecent,
  addRecent,
  clearRecent
};